import { createIcon } from './icon-utils';

export const StepperDownIcon = createIcon({
  path: 'M.94 2.867L3.66 5.38c.192.177.488.177.68 0l2.72-2.512c.203-.187.216-.503.029-.706C6.994 2.058 6.86 2 6.72 2H1.28c-.276 0-.5.224-.5.5 0 .14.058.273.16.367z',
  viewBox: '0 0 8 8',
});
